import styled, { css } from '@app/styled';
import { color, modifier, radius, spacing, transition } from '@app/theme';

const colorPrimary = color('background.action.primary.default');

export const ContentWrapper = styled.div`
    display: flex;
    gap: ${spacing(4)};
    flex-direction: row;
    flex-wrap: nowrap;
    padding-top: ${spacing(6)};
`;

export const ReviewList = styled.ol`
    padding-left: ${spacing(3)};
`;

export const ListItem = styled.li<{ $isHighlighted: boolean }>`
    color: ${color('text.light.default')};
    transition: color ${transition('default')} ease-in-out;

    ${modifier(
        '$isHighlighted',
        css`
            color: ${color('text.default')};
        `,
    )}
`;

export const FeedbackWrapper = styled.div`
    position: relative;
`;

export const FeedbackContent = styled.div`
    position: absolute;
    top: ${spacing(8)};
    left: -${spacing(6)};
    right: -${spacing(6)};
    padding: ${spacing(4)} ${spacing(6)};
    background-color: ${color('background.surface.default')};
    border-radius: ${radius('m')};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
